const NEVYROVNANO = "NEVYROVNANO";
const PREPLATKY = "PREPLATKY";
const NEREALIZOVANE_VRATKY = "NEREALIZOVANE_VRATKY";

const labels = {
    [NEVYROVNANO]: 'Nevyrovnáno',
    [PREPLATKY]: 'Přeplatek',
    [NEREALIZOVANE_VRATKY]: 'Vratka'
};

export const values = [
    NEVYROVNANO,
    PREPLATKY,
    NEREALIZOVANE_VRATKY
];

export function getCaption(typ) {
    return labels[typ];
}
